var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalZakautChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.371,
    height: 21.677,
    viewBox: "0 0 26.371 21.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.542,
    y1: 0.065,
    x2: 0.5,
    y2: 0.827,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(-11349.716 22125.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.141,11.894c-1.752,1.457-5.165-.243-7.947-3.528S.067,0,.067,0,5.233.243,8.014,3.528s3.879,6.91,2.126,8.367",
    transform: "translate(11354.036 -22121.844)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M3.8,15.526c2.288,0,3.8-3.476,3.8-7.763S3.8,0,3.8,0,0,3.476,0,7.763s1.512,7.763,3.8,7.763",
    transform: "translate(11359.102 -22124.949)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.846,11.894c1.752,1.457,5.165-.243,7.947-3.528S10.919,0,10.919,0,5.754.243,2.973,3.528s-3.88,6.91-2.127,8.367",
    transform: "translate(11360.778 -22121.844)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,3.029A8.445,8.445,0,0,1,.6,0,8.552,8.552,0,0,1,2.949,1.9C5.731,5.184,6.828,8.81,5.075,10.267a2.321,2.321,0,0,1-1.39.52C1.462,10.672,0,7.245,0,3.029",
    transform: "translate(11359.102 -22120.215)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M5.921,3.029A8.457,8.457,0,0,0,5.325,0,8.563,8.563,0,0,0,2.973,1.9C.19,5.184-.907,8.81.846,10.267a2.323,2.323,0,0,0,1.39.52c2.223-.114,3.685-3.541,3.685-7.757",
    transform: "translate(11360.778 -22120.215)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M2.118,11.127.526,6.946C-.6,5.513.146,2.736,2.118,0,4.089,2.736,4.834,5.513,3.71,6.946Z",
    transform: "translate(11360.783 -22117.229)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,9.455c-.083-2.485,1.564-5.4,4.453-7.4S10.669-.487,13,.44A16.459,16.459,0,0,0,5.462,3.479,16.267,16.267,0,0,0,0,9.455",
    transform: "translate(11362.903 -22115.398)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M13,9.455c.082-2.485-1.565-5.4-4.453-7.4S2.329-.487,0,.44A16.46,16.46,0,0,1,7.535,3.479,16.27,16.27,0,0,1,13,9.455",
    transform: "translate(11349.9 -22115.398)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check_2_",
    "data-name": "check (2)",
    transform: "translate(11348.762 -22117.713)",
    fill: "#40a87f",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.297168731689453 13.26319789886475 C 7.916539192199707 13.26320743560791 7.558689117431641 13.11495780944824 7.289519309997559 12.84575748443604 L 4.031894683837891 9.588132858276367 C 3.65552020072937 9.232726097106934 3.501396417617798 8.701563835144043 3.629619121551514 8.199497222900391 C 3.758619070053101 7.694367408752441 4.152549266815186 7.300437450408936 4.657679080963135 7.171427249908447 C 4.772889137268066 7.142007350921631 4.891519069671631 7.127087593078613 5.01025915145874 7.127087593078613 C 5.400872707366943 7.127087593078613 5.777734279632568 7.289575099945068 6.045909881591797 7.573276042938232 L 8.224364280700684 9.750693321228027 L 11.54623603820801 5.518257617950439 L 11.32729911804199 5.518257617950439 L 12.23164939880371 4.65611743927002 C 12.49779891967773 4.402747631072998 12.84673881530762 4.263197422027588 13.21417903900146 4.263197422027588 C 13.58976936340332 4.263197422027588 13.94423866271973 4.408067226409912 14.21228885650635 4.671117305755615 C 14.75910758972168 5.207699298858643 14.7861156463623 6.067827701568604 14.27711868286133 6.637341499328613 L 9.365598678588867 12.77981758117676 L 9.354068756103516 12.79423713684082 L 9.341508865356445 12.80776786804199 C 9.079548835754395 13.08991718292236 8.708529472351074 13.25582790374756 8.323578834533691 13.26294708251953 L 8.297168731689453 13.26319789886475 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.21417427062988 4.763197898864746 C 12.9847240447998 4.763197898864746 12.75514984130859 4.848089218139648 12.57640838623047 5.018257141113281 L 12.57764911651611 5.018257141113281 C 12.56892967224121 5.026827812194824 12.56068897247314 5.035887718200684 12.552978515625 5.045387268066406 L 8.269618988037109 10.50286674499512 L 5.687028884887695 7.921507835388184 C 5.456439018249512 7.674047470092773 5.109148025512695 7.572176933288574 4.78140926361084 7.655877113342285 C 4.453679084777832 7.739577293395996 4.197769165039062 7.995487213134766 4.114068984985352 8.323227882385254 C 4.030368804931641 8.650957107543945 4.132228851318359 8.998247146606445 4.379698753356934 9.228837013244629 L 7.643089294433594 12.49222755432129 C 7.820768356323242 12.6699275970459 8.063061714172363 12.76770210266113 8.314329147338867 12.76303672790527 C 8.565579414367676 12.75838756561279 8.804119110107422 12.65171813964844 8.975089073181152 12.46756744384766 L 13.89607906341553 6.313247680664062 C 14.23300933837891 5.945697784423828 14.21797943115234 5.377217292785645 13.86208915710449 5.027987480163574 C 13.68234062194824 4.851597785949707 13.44832229614258 4.763197898864746 13.21417427062988 4.763197898864746 M 13.21417903900146 3.763197898864746 C 13.72153854370117 3.763197898864746 14.20037841796875 3.958897590637207 14.5624885559082 4.314237594604492 C 15.29772472381592 5.035710334777832 15.33732318878174 6.190142631530762 14.65969276428223 6.959515571594238 L 9.733058929443359 13.12090682983398 L 9.707939147949219 13.14795684814453 C 9.354059219360352 13.52911758422852 8.852849006652832 13.7532377243042 8.332829475402832 13.76286697387695 C 8.321429252624512 13.76308727264404 8.309259414672852 13.76319694519043 8.297159194946289 13.76319694519043 C 7.782958984375 13.76319694519043 7.299538612365723 13.56293773651123 6.935938835144043 13.19929695129395 L 3.68262767791748 9.945985794067383 C 3.178537368774414 9.465902328491211 2.972633361816406 8.751337051391602 3.145169258117676 8.075777053833008 C 3.319438934326172 7.393407821655273 3.851589202880859 6.861247062683105 4.53395938873291 6.686977386474609 C 4.689518928527832 6.647237777709961 4.84977912902832 6.627087593078613 5.010258674621582 6.627087593078613 C 5.535423278808594 6.627067565917969 6.042234420776367 6.844522476196289 6.404193878173828 7.224447250366211 L 8.179105758666992 8.998514175415039 L 10.51819133758545 6.018257141113281 L 10.07702922821045 6.018257141113281 L 11.88687896728516 4.293997764587402 C 12.24640846252441 3.95170783996582 12.71778869628906 3.763197898864746 13.21417903900146 3.763197898864746 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalZakautChecked);
export default __webpack_public_path__ + "static/media/salZakautChecked.ec1fa5d1ef07d468e7fe312fcdd1cd1d.svg";
export { ForwardRef as ReactComponent };